import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-cop-main',
  templateUrl: './cop-main.component.html',
  styleUrls: ['./cop-main.component.scss']
})
export class CopMainComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
